//本地存储封装
const KEY_USER = "user"
let SessionStore = {
    //设置用户
    setUser(user){
        this.setObject(KEY_USER, user);
    },
    //获取用户
    getUser() {
        return this.getObject(KEY_USER)
    },
    //清除用户
    clearUser() {
        this.clear(KEY_USER)
    },
    setObject(k, v) {
        sessionStorage.setItem(k, JSON.stringify(v))
    },
    getObject(k) {
        let str = sessionStorage.getItem(k)
        if(!str) return null;
        return JSON.parse(str);
    },
    getObjectAndClear(k) {
      let obj = this.getObject(k);
      this.clear(k);
      return obj;
    },
    set(k, v){
        sessionStorage.setItem(k, v);
    },
    get(k) {
        return sessionStorage.getItem(k)
    },
    clear(k) {
        sessionStorage.removeItem(k);
    }
}

export default SessionStore;
